import React from "react";
import Card from "react-bootstrap/Card";
// import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Vivo en <span className="purple"> Tartagal, Salta, Argentina.</span>
            <br />
            <br />
            Tengo experiencia en diversos proyectos universitarios, los cuales me han permitido desarrollar habilidades prácticas en el diseño y desarrollo de aplicaciones web.
             Actualmente, estoy en búsqueda de mis primeras experiencias laborales en el área del desarrollo frontend.
             <br />
             <br />
            Además, estudio la 
            <span className="purple"> Tecnicatura Universitaria en Diseño y Desarrollo de Videojuegos.</span> Entre las actividades que realizo también se encuentran 
            el modelado 3D con Blender, la edición gráfica en Photoshop, Illustrator.
          </p>
          {/* <ul>
            <li className="about-activity">
              <ImPointRight /> Modelar 3D en Blender
            </li>
            <li className="about-activity">
              <ImPointRight /> Editar en Photoshop/Illustrator.
            </li>
          </ul> */}
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
